import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonical,
  type = 'website',
  image = 'https://customer-assets.emergentagent.com/job_digital-transform-45/artifacts/zhvprbqi_logomark_web_large_1024x1024.png'
}) => {
  const siteTitle = 'Resolv Digital';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | CRM, ERP & AI Systems Consultants Gold Coast`;
  
  // Generate dynamic canonical URL based on current location
  const dynamicCanonical = typeof window !== 'undefined' 
    ? window.location.href.split('?')[0] // Remove query params
    : canonical;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={dynamicCanonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={dynamicCanonical} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
